import LiveKitTelemedicineFinishedContainer from './LiveKitTelemedicineFinishedContainer';
import TelemedicineFinished from './TelemedicineFinished';

import TelemedicineContext from '../../context/telemedicine';
import { LIVEKIT_PROVIDER } from '../../utils/telemedicine';

import { useContext } from 'react';

const TelemedicineFinishedContainer = () => {
	const { telemedicine } = useContext(TelemedicineContext);

	if (telemedicine?.provider === LIVEKIT_PROVIDER) {
		return <LiveKitTelemedicineFinishedContainer />;
	}

	return (
		<TelemedicineFinished
			date={telemedicine.attendance?.start_date ? telemedicine.attendance.start_date : telemedicine.created_at}
			user={telemedicine.user}
		/>
	);
};

export default TelemedicineFinishedContainer;
